import { cacheDecorator } from '@ds/swymkit/tools'

import { swymFetch } from '~/services/fetch-swym'

import type { IParams } from '~/features-shared/content/api/interfaces/params'
import { logger } from '~/features-shared/libs/utils/logger'

import type { ExaleadStatsResponse } from '~/interfaces/services-dto'

const SEARCH_STATS_URL = '/api/exalead/searchstats'

async function searchStats(params?: IParams) {
  try {
    const id = params?.community_id?.split(':')
      .pop()
    const response = await swymFetch
      .post(SEARCH_STATS_URL, {
        json: {
          params: {
            community_id: id || null,
            content_type: params?.content_type ? [params.content_type] : null,
          },
        },
      })
      .json<ExaleadStatsResponse>()

    return response.limitedResults
  }
  catch (err) {
    logger.error(err)
    // Do not limit results if API fails
    return false
  }
}

// Cache the results for 30 sec
export async function shouldLimitExaleadResults(params?: IParams) {
  return cacheDecorator(
    `search-stats-${params?.community_id || 'whatsnew'}-${params?.content_type || 'all'}`,
    () => searchStats(params),
    30 * 1000,
  )
}
